import React, { Component } from "react";
import PropTypes from "prop-types";
import Message from "./Message";
import "./MessageList.css";

class MessageList extends Component {
  static propTypes = {
    messages: PropTypes.arrayOf(PropTypes.object),
    host: PropTypes.object,
    readInfo: PropTypes.object
  };

  static defaultProps = {
    messages: [],
    host: {},
    readInfo: {}
  };

  componentDidUpdate = () => {
    this.node.scrollTop = this.node.scrollHeight;
  };

  render() {
    const { messages, host, readInfo } = this.props;

    const lastSentdMessageIndex = [...messages]
      .reverse()
      .find(msg => msg.authorId && msg.authorId === host.id)?.index;

    return (
      <div className="MessageList" ref={node => (this.node = node)}>
        {messages.map((message, i) => (
          <Message
            key={i}
            host={host}
            readInfo={readInfo}
            isLastSent={message.index === lastSentdMessageIndex}
            {...message}
          />
        ))}
      </div>
    );
  }
}

export default MessageList;
